
define('text!views/pages/cash/methods/AmountOnlyDepositViewModel.html',[],function () { return '<div data-bind="compose: { model: wizardModel, view: \'views/pages/cash/cashWizard.html\' }"></div>';});

